module.exports = __webpack_public_path__ + "kp.69b9a975.svg";